import { createApi } from "@reduxjs/toolkit/query/react";
import { publicBaseQuery } from "@/api/base/public/publicBaseQuery";

function getLocaleHeader(): string {
  if (typeof document === "undefined") return "en";
  const m = document.cookie.match(/(?:^|;\s*)NEXT_LOCALE=([^;]+)/);
  return m?.[1] ? decodeURIComponent(m[1]) : "en";
}

export type RegisterBySlugPayload = {
  invite_code: string;
  firstname?: string | null;
  lastname?: string | null;
  patronymic?: string | null;
  password?: string | null;
  recaptcha_token?: string | null;
  agree?: 0 | 1;

  /**
   * Registrant contact (phone was replaced by email).
   */
  email?: string | null;

  /**
   * Usually used as "username" (e.g. IIN).
   * Example from backend:
   *   "username":"031217500407"
   */
  username?: string | null;

  /**
   * Dynamic fields (example from backend):
   *   astana_daryn_school_id
   *   astana_daryn_teacher_name
   *   astana_daryn_class_name
   *
   * We keep it flexible because the prefix depends on {slug}.
   */
  [key: string]: unknown;
};

export type RegisterBySlugResponse = unknown;

export const registerBySlugPublicApi = createApi({
  reducerPath: "registerBySlugPublicApi",
  baseQuery: publicBaseQuery(),
  endpoints: (builder) => ({
    validateRegisterBySlug: builder.mutation<
      RegisterBySlugResponse,
      { slug: string; payload: RegisterBySlugPayload }
    >({
      query: ({ slug, payload }) => ({
        url: `/api/register/validate.json`,
        method: "POST",
        data: payload,
        headers: { locale: getLocaleHeader() },
      }),
    }),

    submitRegisterBySlug: builder.mutation<
      RegisterBySlugResponse,
      { slug: string; payload: RegisterBySlugPayload }
    >({
      query: ({ slug, payload }) => ({
        url: `/api/register/submit.json`,
        method: "POST",
        data: payload,
        headers: { locale: getLocaleHeader() },
      }),
    }),
  }),
});

export const { useValidateRegisterBySlugMutation, useSubmitRegisterBySlugMutation } =
  registerBySlugPublicApi;
